module.exports = __webpack_public_path__ + "static/mo26-4bcd1f5c2659e139e275b58685324f35.png";